import React from "react";
import { Card } from "components";
import { Grid, Archive, Upload } from "../icons";

const SOON = [
  { icon: <Grid />, name: "Start from a pre-made game" },
  { icon: <Archive />, name: "Import from J! Archive" },
  { icon: <Upload />, name: "Import from CSV" },
];

const ComingSoonStrip = () => (
  <>
    <div className="cg-soon-head">More ways to start · coming soon</div>
    <div className="cg-soon-grid">
      {SOON.map((s) => (
        <Card key={s.name} dashed padding="md" className="cg-soon-card">
          <span className="cg-soon-icon">{s.icon}</span>
          <span>
            <span className="name">{s.name}</span>
            <span className="tag" style={{ display: "block" }}>Coming soon</span>
          </span>
        </Card>
      ))}
    </div>
  </>
);

export default ComingSoonStrip;
